import { call, all } from 'redux-saga/effects';

import { desksSaga } from './desksSlice/desksSagas';
import { tableControlSaga } from './tableControlSlice/tableControlSagas';
import { formControlSaga } from './formControlSlice/formControlSagas/index.js';
import { authSaga } from './authSlice/authSagas';
import { featureFlagSaga } from './featureFlag/featureFlagSaga';
import { relayActivitySaga } from 'features/relayActivity/store/relayActivitySagas';
import { transactionImageSaga } from './storeTransactionImage/storeTransactionImageSaga';
import { draftMailSaga } from './draftMail/draftMailSaga';
import { transactionsSaga } from './transactionsSlice/transactionSagas/root';
import { faceMatchSaga } from './faceMatchSlice/faceMatchSagas';
import { allEventsSaga } from './allEventsSlice/allEventsSagas';
import { fenixYmsSaga } from './fenixYmsSlice/fenixYmsSagas';
import { activityTrackingSaga } from './activityTracking/activityTrackingSagas';
import { ocrVerificationSaga } from './ocrVerificationSlice/ocrVerificationSagas';
import { slackSaga } from './slackSlice/slackSagas';
import { stepByStepProtocolSaga } from 'features/stepByStepProtocol';

export default function* rootSaga() {
    yield all([
        call(fenixYmsSaga),
        call(desksSaga),
        call(transactionsSaga),
        call(tableControlSaga),
        call(formControlSaga),
        call(authSaga),
        call(featureFlagSaga),
        call(relayActivitySaga),
        call(transactionImageSaga),
        call(draftMailSaga),
        call(faceMatchSaga),
        call(allEventsSaga),
        call(activityTrackingSaga),
        call(slackSaga),
        call(ocrVerificationSaga),
        call(stepByStepProtocolSaga),
    ]);
}
